/**
 * Crea un onBlur que elimina **todos** los espacios y luego delega a las funciones proporcionadas.
 * @param field        - Nombre del campo
 * @param setFieldValue- Función para actualizar el valor (p.ej. Formik's setFieldValue)
 * @param handleBlur   - Función para manejar el blur (p.ej. Formik's handleBlur)
 * @returns Handler onBlur
 */
export function createRemoveAllSpacesBlurHandler(
  field: string,
  setFieldValue: (
    field: string,
    value: unknown,
    shouldValidate?: boolean
  ) => void,
  handleBlur: React.FocusEventHandler<HTMLInputElement>
): React.FocusEventHandler<HTMLInputElement> {
  return (e) => {
    const cleaned = e.currentTarget.value.replace(/\s+/g, '');
    handleBlur(e);
    setFieldValue(field, cleaned, true);
  };
}
